import { useState } from 'react';

export function AuthModal({ mode, setMode, onClose, onSuccess }) {
  const [email, setEmail] = useState('');
  const isSignIn = mode === 'signin';

  const submit = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    onSuccess(email.trim());
  };

  return (
    <div className="overlay" onClick={onClose} role="presentation">
      <div className="modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-labelledby="auth-title">
        <button className="close-x" onClick={onClose} aria-label="Close">×</button>
        <h2 id="auth-title">{isSignIn ? 'Sign in' : 'Create your account'}</h2>
        <p>{isSignIn ? 'Sign in to manage trips and reviews.' : 'Register to save apartments and book faster.'}</p>
        <form onSubmit={submit}>
          <label className="field-label" htmlFor="auth-email">Email address</label>
          <input id="auth-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <label className="field-label" htmlFor="auth-pass">Password</label>
          <input id="auth-pass" type="password" defaultValue="" required minLength={6} />
          <button className="modal-primary" type="submit">{isSignIn ? 'Sign in' : 'Register'}</button>
        </form>
        <p className="modal-note">
          {isSignIn ? "Don't have an account yet? " : 'Already have an account? '}
          <button type="button" onClick={() => setMode(isSignIn ? 'register' : 'signin')}>
            {isSignIn ? 'Create your account' : 'Sign in'}
          </button>
        </p>
      </div>
    </div>
  );
}
